<template>
  <div id="reportFilters">
    <v-col class="clearColumnPadding mb-2">
      <h4 class="font-weight-light pt-3">{{labels.options}}</h4>
    </v-col>
    <v-col class="clearColumnPadding mb-4">
      <v-autocomplete
        dense
        outlined
        :items="availableReports"
        v-model="selectedReport"
        item-text="reportName"
        item-value="reportKey"
        :label="labels.selectReport"
        @change="selectedReportChanged"
        hide-details="auto"
      >
      <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title>{{data.item.reportName}}</v-list-item-title>
          </v-list-item-content>
      </template>
      </v-autocomplete>
    </v-col>
    <FilterBuilder
      v-if="selectedReport != ''"
      :formElements="selectedFilters"
      :noDateFilter="noDateFilter"
      :endPoint="reportEndPoint"
      :monthPeriodInterval="dateTimePickerMonthPeriodInterval"
      :method="reportMethod"
      @apiResponded = triggerEventBusAfterReportIsGenerated
    />
    <br>
  </div>
</template>

<script>
import Reports from '../../resource/reports/reports.json'
import ReportFilters from '../../resource/reports/reportFilters.json'
import FilterBuilder from './FilterBuilder'
import translate from '@/utils/genTable/multilanguageHelper.js'
import store from '@/store/store'
import { useCaseMap } from '../../utils/useCase/useCaseMap'

//Store
import EventBus from '../../event-bus'

export default {
  name: 'ReportFilters',
  components: {
    FilterBuilder,
    EventBus
  },
  data() {
    return {
      showLoading: false,
      reportEndPoint: '',
      showSearch: false,
      selectedReport: '',
      actualSelectedReport: '',
      reportNote: '',
      sorts: null,
      labels: {
        selectReport: translate('Select report', 'reports.filter'),
        filters: translate('Filters', 'mapFilters'),
        options: translate('Options', 'mapFilters')
      },
      selectedFilters: [],
      valid: true,
      reportRequestObject: {},
      reportMetadata: {},
      excludedColumns: [],
      dateTimePickerMonthPeriodInterval: 1,
      reportMethod: 'get'
    }
  },
  computed: {
    availableReports() {
      let allowedUseCases = JSON.parse(store.getters['user/jwtData'].UserData).AllowedUseCaseIds
      return Reports.reports.filter(el => allowedUseCases.includes(useCaseMap[el.useCase])).map(el => {
        return {
          reportName: translate(el.reportName, 'reports.filter'),
          reportKey: el.reportKey,
          reportFilters: el.reportFilters,
          useCase: el.useCase,
          noDateFilter: el.noDateFilter,
          sorts: el.sorts,
          showSearch: el.showSearch,
          excludedColumns: el.excludedColumns,
          excludeDownload: el.excludeDownload ? el.excludeDownload : false,
          method: el.method || 'get'
        }
      })
    }
  },
  methods: {
    selectedReportChanged() {
      const selectedReport = this.availableReports.find(
        report => report.reportKey == this.selectedReport
      )
      if (selectedReport.sorts) this.sorts = selectedReport.sorts
      this.reportEndPoint = 'reports/' + selectedReport.reportKey
      this.excludedColumns = selectedReport.excludedColumns
      if (selectedReport == null) {
        throw new Error(`Failed to find Report. Please verify that report with 
          [${this.selectedReport}] key exists and is supported.`)
      }
      const filtersForSelectedReport = []

      this.showSearch = selectedReport.showSearch

      selectedReport.reportFilters.forEach(filter => {
        var foundFilter = ReportFilters.filters.find(x => x.name == filter)
        if (foundFilter != null) {
          if (Array.isArray(foundFilter.data)) {
            for (let singleFilter of foundFilter.data) {
              filtersForSelectedReport.push(singleFilter)
            }
          } else {
            filtersForSelectedReport.push(foundFilter.data)
          }
        }
      })

      this.reportNote = selectedReport.reportNote
      if (
        !this.selectedFilters.length ||
        this.areArrayDifferent(this.selectedFilters, filtersForSelectedReport)
      ) {
        this.selectedFilters = filtersForSelectedReport
      }
      this.noDateFilter = selectedReport.noDateFilter
      this.reportMethod = selectedReport.method || 'get'
      this.actualSelectedReport = this.selectedReport
      console.log("actual selected report: ", this.actualSelectedReport)

      if (this.actualSelectedReport == "TotalCoveredDistanceSummary") {
        this.dateTimePickerMonthPeriodInterval = 6
      } else {
        this.dateTimePickerMonthPeriodInterval = 1
      }
    },
    areArrayDifferent(filters1, filters2) {
      if (filters1.length != filters2.length) {
        return true
      }
      let areDifferent = false
      for (let filter1 of filters1) {
        let isEqual = false
        for (let filter2 of filters2) {
          if (filter2.key == filter1.key) isEqual = true
        }
        if (!isEqual) {
          areDifferent = true
          break
        }
      }
      return areDifferent
    },
    triggerEventBusAfterReportIsGenerated(response) {
      var selectedReportObject = this.availableReports.find(
        report => report.reportKey == this.selectedReport
      )
      EventBus.$emit('REPORT_GENERATED', {
        data: response,
        metadata: {
          excludedColumns: this.excludedColumns,
          report: this.selectedReport,
          showSearch: this.showSearch,
          startDate: response.choosenDates.startDate,
          endDate: response.choosenDates.endDate,
          excludeDownload: selectedReportObject.excludeDownload
        },
        sorts: this.sorts
      })

      this.showLoading = false
    }
  }
}
</script>
<style scoped>
.clearColumnPadding {
  padding: 0px;
}
</style>
